<app-tooltip
  id="shared-label-radio-option-tooltip"
  class="shared-label-radio-option-tooltip"
  [tootltipText]="tooltipTextKey | translate"
  [tooltipPosition]="'above'"
  [tooltipDelay]="'100'"
  [disabled]="disableTooltip"
>
  <mat-radio-button
  disableRipple
    class="tooltip-content eds-radio"
    [value]="value"
    (change)="onChange(value)"
    [color]="defaultColor"
    [class]="radioType"
    [disabled]="disabled"
    [checked]="checked"
    [formControl]="dataControl"
    ngDefaultControl
    [name]="name"
  >


    <span id="shared-radio-button-text-wrapper" class="radiobutton-text">
      <app-text id="shared-radio-button-text" [textStyleType]="fontType">{{
        title
      }}</app-text>
    </span>
  </mat-radio-button>
</app-tooltip>
